import { render, staticRenderFns } from "./STErrorsDefault.vue?vue&type=template&id=8ea49ab4"
import script from "./STErrorsDefault.vue?vue&type=script&lang=ts"
export * from "./STErrorsDefault.vue?vue&type=script&lang=ts"
import style0 from "./STErrorsDefault.vue?vue&type=style&index=0&id=8ea49ab4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports